<template>
  <div id="print-page">
    <div class="print-page-wrapper">
      <div class="page-content">
        <table id="page-layout">
          <thead>
            <tr>
              <td>
                <div class="header-space">&nbsp;</div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content"><slot></slot></div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <div class="footer-space">&nbsp;</div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="page-footer"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: [],
  data() {
    return {};
  },
  mounted() {
    this.$store.dispatch("ui/togglePrintView");
  },
  methods: {}
};
</script>
<style lang="scss">
.footer-divider {
  display: block;
  border-bottom: 1px solid #333;
  border-top: 1px solid #333;
  padding: 2px;
  margin-bottom: 8px;
  margin-top: 8px;
}
.header-text .sub-header {
  width: 100%;
  text-align: center;
  display: block;
  font-size: 10px;
}
#print-page {
  display: flex;
  align-items: center;
  flex-direction: column;
  background: #dadce0;
  padding-top: 30px;
  padding-bottom: 30px;
  font-size: 16px;
  font-family: "Calibri", sans-serif;
  .print-page-wrapper {
    width: 296mm;
    min-height: 209mm;
    padding: 14mm 8mm;
    background: #fff;
  }
  .page-header {
    display: flex;
    font-family: "Times-New-Roman", serif;
    justify-content: center;
    .header-logo {
      width: 60px;
      margin-right: 15px;
      img {
        width: 100%;
      }
    }
    .header-text {
      margin-top: -5px;
      h3 {
        font-size: 24px;
        margin-top: -10px;
        border-bottom: 2px solid #4343a1;
      }
    }
  }
  .footer-content {
    margin-top: 30px;
    font-size: 12px;
  }
  .page-content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    #page-layout {
      width: 100%;
      // margin-top: calc(120px - 72px);
      > thead {
        display: none;
      }
      > tfoot {
        display: none;
      }
    }
  }
}

#extrafooter {
  color: #333;
  a {
    color: #333;
  }
}

.custom-footer {
  font-size: 14px;
}

@media screen {
  .print-page-wrapper {
    display: flex;
    flex-direction: column;
    .page-content {
      flex-grow: 1;
    }
  }
  .page-footer {
    // position: absolute;
    // bottom: 50px;
    // width: 687px;
  }
}

@media print {
  body,
  #app {
    height: 100%;
  }
  #print-page {
    padding-top: 0;
    padding-bottom: 0;
    .page-header {
      width: 100%;
      position: fixed;
      top: 10px;
      left: 0;
      padding-top: 8mm;
      overflow: hidden;
    }
    .page-footer {
      width: 100%;
      position: fixed;
      bottom: 10px;
      left: 0;
      overflow: hidden;
      padding-bottom: 5mm;
      .footer-content {
        margin-top: 0;
      }
      .footer-divider {
        width: 90%;
        margin-left: 5%;
      }
    }
    .print-page-wrapper {
      padding-top: 0;
      padding-bottom: 0;
      width: 100% !important;
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
    // .header-space {
    //   height: 150px;
    // }
    // .footer-space {
    //   height: 115px;
    // }
    #page-layout {
      > thead {
        display: table-header-group !important;
      }
      > tfoot {
        display: table-footer-group !important;
      }
    }
  }
  #extrafooter {
    margin-left: 14mm;
    .ui-icon {
      display: none;
    }
  }
  .custom-footer {
    margin-left: 14mm;
  }
  .h-print {
    display: none;
  }
}

@page {
  size: A4 landscape;
  margin: 0;
}

table {
  page-break-inside: auto;
}
tr {
  page-break-inside: avoid;
  page-break-after: auto;
}
</style>
